import { CollectionViewer } from '@angular/cdk/collections';
import { SiteState } from '@next/core-lib/site';
import { AgrDataSource } from '@next/core-lib/table-v2';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { FertiliserOrderplanTable } from '../models';

export class FertilisersOrderplanDataSource extends AgrDataSource<FertiliserOrderplanTable> {
  public data$ = new BehaviorSubject<FertiliserOrderplanTable[]>([]);

  private readonly destroySubject$ = new Subject<boolean>();

  constructor(private store: Store<SiteState>) {
    super();
  }

  connect(_: CollectionViewer): Observable<FertiliserOrderplanTable[]> {
    this.loadingSubject.next(false);
    return this.data$;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    super.disconnect(collectionViewer);
    this.destroySubject$.next(true);
    this.destroySubject$.complete();
  }
}
